import ResumesFilterOption from './ResumesFilterOption'
import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export type ResumesFilterType = 'checkbox' | 'multiselect' | 'multi-selector' | 'search'

export default class ResumesFilter extends BaseModel {
  static override constructorName = 'ResumesFilterModel'

  id: string = ''
  name: string = ''
  type: ResumesFilterType = 'checkbox'
  value: string | ResumesFilterOption[] = ''
  options: ResumesFilterOption[] = []

  constructor(data?: unknown) {
    super(data)

    if (!isUnknownObject(data)) {
      return
    }

    fillOwnProperties(this, data, ['options', 'value'])

    this.options = Array.isArray(data.options)
      ? data.options.map(item => new ResumesFilterOption(item))
      : []

    this.value = Array.isArray(data.value)
      ? data.value.map(item => new ResumesFilterOption(item))
      : String(data.value ?? '')
  }
}

registerModel(ResumesFilter)
